export class UserInfoModel {
    userroles: string;
    products: any[];
    allProducts: any[];
}